import { AxiosResponse } from "axios";
import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { TResponse } from "../../../types/common";
import { ICompany, ICompanyUpdatePayload } from "../../../types/api/company";

export async function getMyCompany(): Promise<AxiosResponse<TResponse<ICompany>>> {
  return axios.get<TResponse<ICompany>>(API_ENDPOINTS.MY_COMPANY);
}

export async function updateMyCompany(
  data: ICompanyUpdatePayload
): Promise<AxiosResponse<TResponse<ICompany>>> {
  return axios.put<TResponse<ICompany>>(API_ENDPOINTS.MY_COMPANY, data);
}
